import React from 'react';

const WhySunServ = () => {
  const benefits = [
    {
      icon: 'fa-rocket',
      title: 'Haute performance',
      description: 'Infrastructure optimisée pour des temps de chargement ultra-rapides'
    },
    {
      icon: 'fa-shield-alt',
      title: 'Protection DDoS',
      description: 'Sécurité renforcée contre les attaques malveillantes'
    },
    {
      icon: 'fa-headset',
      title: 'Support 24/7',
      description: 'Une équipe dédiée disponible à tout moment'
    }
  ];

  return (
    <div className="bg-gradient-to-br from-yellow-400/10 to-yellow-600/10 rounded-xl p-6 border border-yellow-400/20">
      <h3 className="text-lg font-bold text-white mb-4 flex items-center">
        <i className="fas fa-star text-yellow-400 mr-2"></i>
        Pourquoi SunServ ?
      </h3>
      <p className="text-sm text-gray-300 mb-4">
        Hébergez vos serveurs de jeu sur une infrastructure professionnelle, performante et sécurisée.
      </p>
      <div className="space-y-3 mb-5">
        {benefits.map((benefit, index) => (
          <div key={index} className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-lg bg-yellow-400/20 flex items-center justify-center flex-shrink-0">
              <i className={`fas ${benefit.icon} text-yellow-400 text-sm`}></i>
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-medium text-white mb-0.5">
                {benefit.title}
              </h4>
              <p className="text-xs text-gray-400">
                {benefit.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <a
        href="https://sunserv.fr"
        target="_blank"
        rel="noopener noreferrer"
        className="block w-full bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-gray-900 font-semibold py-2.5 rounded-lg transition-all hover:scale-105 text-center"
      >
        Découvrir nos offres
      </a>
    </div>
  );
};

export default WhySunServ;
